import { gql } from 'graphql-request';

import {
  TeamCreatedAt,
  TeamID,
  TeamImageFile,
  TeamName,
  TeamNanoID,
  TeamOwnerEmail,
  TeamOwnerID,
  TeamOwnerNanoID,
  TeamPreferredPaymentMethod,
  TeamTerms,
  TeamUUID
} from '../teamsTypes';

export interface FetchCacheSelectFieldTeamsQueryResponse {
  id: TeamID;
  nanoId: TeamNanoID;
  uuid: TeamUUID;
  name: TeamName;
  createdAt: TeamCreatedAt;
  image?: {
    file: TeamImageFile;
  };
  owner?: {
    id: TeamOwnerID;
    nanoId: TeamOwnerNanoID;
    email: TeamOwnerEmail;
  };
  ownerId?: TeamOwnerID;
  preferredPaymentMethod?: TeamPreferredPaymentMethod;
  terms?: TeamTerms;
}

export const FETCH_CACHE_SELECT_FIELD_TEAMS_QUERY = gql`
  query CacheSelectFieldTeams(
    $filters: TeamsFilters
    $sort: [TeamsSortEnum]
    $limit: Int
    $offset: Int
    $source: String
    $trackTotalHits: Boolean
  ) {
    teams(
      filters: $filters
      sort: $sort
      limit: $limit
      offset: $offset
      source: $source
      trackTotalHits: $trackTotalHits
    ) {
      nodes {
        id
        nanoId
        uuid
        name
        createdAt
        image {
          file
        }
        owner {
          id
          nanoId
          email
        }
        ownerId
        preferredPaymentMethod
        terms
      }
      paginationInfo {
        nextPage
        totalCount
      }
      sql
    }
  }
`;
